"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _sessionStateEmitter["default"];
  }
});
var _sessionStateEmitter = _interopRequireDefault(require("./sessionStateEmitter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }